import { useSelector } from 'react-redux'
import AuthExperienceSelectors from '../../selectors/experiences/Auth'

/**
 * True once REST session is ready (token validated and profile loaded via HTTP).
 * Independent of socket.io — real-time features may connect later or fail without blocking CRUD.
 */
const useProtectedApiReady = () => useSelector(AuthExperienceSelectors.isAuthenticated)

export default useProtectedApiReady
